import {HomeOutlined, UserOutlined} from '@ant-design/icons';
import {Breadcrumb} from 'antd';

// eslint-disable-next-line import/namespace,import/default
import UserHistory from '../SingleUser/UserHistory/UserHistory';

const Order =() =>{
  return(
    <div className={'lg:p-6'}>
      <div className={'mb-5'}>
        <Breadcrumb className={'md:flex hidden'}
          items={[
            {
              href: '/dashboard',
              title: <HomeOutlined />,
            },
            {
              href: '/order',
              title: (
                <>
                  <UserOutlined />
                  <span>Order</span>
                </>
              ),
            },
          ]}
        />
      </div>
      <UserHistory />
    </div>
  );
};

export default Order;
